import React from "react";
import whatsapp from "images/whatsapp-icon.png"

export interface WhatsAppProps {
    className?: string;
}

const WhatsApp: React.FC<WhatsAppProps> = ({ className = "" }) => {

    const hadleWhatsAppClick = () => {
        window.open("https://wa.me/972526250707?text=%D7%A9%D7%9C%D7%95%D7%9D%2C%20%D7%A4%D7%A0%D7%99%D7%AA%D7%99%20%D7%90%D7%9C%D7%99%D7%9B%D7%9D%20%D7%93%D7%A8%D7%9A%20%D7%94%D7%90%D7%AA%D7%A8%20%D7%95%D7%90%D7%A9%D7%9E%D7%97%20%D7%9C%D7%A7%D7%91%D7%9C%20%D7%9E%D7%99%D7%93%D7%A2%20%D7%A0%D7%95%D7%A1%D7%A3");
    }

    return (
        <button
            onClick={hadleWhatsAppClick}
            className={`text-2xl md:text-3xl w-10 h-10 rounded-full text-neutral-700 dark:text-neutral-300 hover:bg-neutral-100 dark:hover:bg-neutral-800 focus:outline-none flex items-center justify-center ${className}`}
        >
            <span className="sr-only">WhatsApp</span>
            <img className="w-full" src={whatsapp} alt="WhatsApp" />
        </button>
    );
};

export default WhatsApp;
